import React from "react";
import "../nav/Navigation.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCoins} from "@fortawesome/free-solid-svg-icons";

interface Props {
  points: number
}

function PointsTag(props: Props) {

    return (
        <>
            <div className={`user-tag d-inline-block`}>
              <div className={"d-inline-block"}><FontAwesomeIcon className="animated zoomIn fa-solid" icon={faCoins}/></div>
              <div className={"d-inline-block ml-1"}>{props.points}</div>
            </div>
        </>
    )
}

export default PointsTag;
